import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class GetDashboardReportArgs {
  @Field({ nullable: true })
  fromDate?: Date

  @Field({ nullable: true })
  toDate?: Date

  @Field({ nullable: true })
  type?: string
}
